import React, { useEffect } from "react";
import { Grid, makeStyles } from "@material-ui/core";
import { UpdateRiskHeader } from "./UpdateRiskHeader";
import { UpdateRiskDetails } from "./UpdateRiskDetails";
import { Tabs } from "@ofqual/portal-components/components/Tabs";
import { useDispatch, useSelector } from "react-redux";
import { submissionSelector } from "../../redux/selectors";
import { useParams } from "react-router-dom";
import { loadingSubmission } from "../../redux/actions";
import { Skeleton } from "@material-ui/lab";
import { RiskAppBar } from "../RiskAppBar";
import { SubmissionActivityFeed } from "./activityFeed/SubmissionActivityFeed";
import { ScrollableAreaTabs } from "@ofqual/portal-components/components/ScrollableAreaTabs";
import {
  LinkedRecords,
  LinkedRecordType,
} from "@ofqual/portal-linked-records/linked-records";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.contentOffsets.AFTER_RECORD_HEADER,
  },
}));

export const UpdateRisk: React.FC = () => {
  const classes = useStyles();

  const dispatch = useDispatch();
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    dispatch(loadingSubmission(id));
  }, [dispatch, id]);

  const submissionState = useSelector(submissionSelector);
  return (
    <>
      <div className={classes.root}>
        <RiskAppBar
          breadcrumbs={[
            { label: "Submit observations, intelligence or analysis" },
          ]}
        />
        <UpdateRiskHeader
          submissionState={submissionState}
          key={submissionState.versionId}
        />
        <Grid container spacing={3}>
          <Grid item md={8}>
            <Tabs
              currentTabId=""
              onTabChange={(newTabId) => console.log(newTabId)}
              tabs={[{ id: "", label: "Submission Details" }]}
            />
            {submissionState.submission ? (
              <UpdateRiskDetails
                submissionState={submissionState}
                key={submissionState.versionId}
              />
            ) : (
              <>
                <Skeleton variant="text" height={60} />
                <Skeleton variant="text" height={60} />
                <Skeleton variant="text" height={60} />
                <br />
                <Skeleton variant="rect" height={118} />
              </>
            )}
          </Grid>
          <Grid item md={4} xs={12}>
            <ScrollableAreaTabs
              tabs={[
                {
                  label: "Activity",
                  content: (
                    <SubmissionActivityFeed
                      submission={submissionState.submission}
                    />
                  ),
                },
                {
                  label: "Linked Records",
                  content: (
                    <LinkedRecords
                      entityReferenceId={submissionState.submission?.id}
                      entityTitle={submissionState.submission?.subject}
                      entityLinkedRecordType={LinkedRecordType.risk}
                    />
                  ),
                  tabTypeId: "linkedRecords",
                },
              ]}
            ></ScrollableAreaTabs>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
